export default __webpack_public_path__ + "static/4-48957c3c30fd715ef44fb28af58a98f5.png";